import { ReactElement } from 'react';
import { styled } from 'styled-components';

const Wrapper = styled.span`
  color: #8c8c8c;
`;

const TimeRangeSeparator = (): ReactElement => <Wrapper>〜</Wrapper>;

export default TimeRangeSeparator;
